import { DEFAULT_CURRENCY } from '@/data/config/DEFAULTS';
import { BuildGA4ViewItemListEventPayloadProps } from 'presentation/events/hooks/useTrackViewItemList/types';
import {
	GA4EcommerceEventItemPayload,
	GA4EcommerceEventPayload,
} from 'presentation/events/types/ga4Types';
import { buildGA4EcommerceEventItemPayload } from 'presentation/events/utils/ga4Utils';

export const buildGA4ViewItemListEventPayload = (
	props: BuildGA4ViewItemListEventPayloadProps
): GA4EcommerceEventPayload => {
	const { physicalStoreId, settings } = props;

	let items: GA4EcommerceEventItemPayload[] = [];

	items = props.items.map((item, index) =>
		buildGA4EcommerceEventItemPayload({
			product: item.product,
			categories: item.categories,
			physicalStoreId,
			settings,
			quantity: item.quantity,
			promotionDetails: item.promotionDetails,
			index: index + 1,
		})
	);

	const payload: GA4EcommerceEventPayload = {
		event: props.event,
		ecommerce: {
			currency: DEFAULT_CURRENCY,
			items,
		},
	};

	return payload;
};
